var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItemTypeRegularIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14H21",
    stroke: "#1F1F1F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.4999V12.9999C21 12.0324 21.2808 11.0856 21.8082 10.2744C22.3357 9.4632 23.0872 8.82248 23.9716 8.42994C24.8559 8.03741 25.8352 7.90991 26.7906 8.06291C27.7461 8.21591 28.6365 8.64284 29.3541 9.29192C30.0717 9.94101 30.5855 10.7844 30.8333 11.7197C31.0811 12.655 31.0521 13.6421 30.75 14.5613C30.4478 15.4805 29.8855 16.2923 29.1311 16.8982C28.3767 17.5042 27.4627 17.8782 26.5 17.9749V21.9999C26.5 22.2652 26.3946 22.5195 26.2071 22.707C26.0196 22.8946 25.7652 22.9999 25.5 22.9999H7.5C7.23478 22.9999 6.98043 22.8946 6.79289 22.707C6.60536 22.5195 6.5 22.2652 6.5 21.9999V17.9749C5.53726 17.8782 4.62328 17.5042 3.86891 16.8982C3.11453 16.2923 2.55217 15.4805 2.25003 14.5613C1.94788 13.6421 1.91894 12.655 2.1667 11.7197C2.41447 10.7844 2.9283 9.94101 3.64587 9.29192C4.36345 8.64284 5.25395 8.21591 6.20936 8.06291C7.16477 7.90991 8.14406 8.03741 9.02844 8.42994C9.91283 8.82248 10.6643 9.4632 11.1918 10.2744C11.7192 11.0856 12 12.0324 12 12.9999V17.4999",
    stroke: "#1F1F1F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.025V6C6.5 4.93913 6.92143 3.92172 7.67157 3.17157C8.42172 2.42143 9.43913 2 10.5 2H22.5C23.5609 2 24.5783 2.42143 25.3284 3.17157C26.0786 3.92172 26.5 4.93913 26.5 6V8.025",
    stroke: "#1F1F1F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemTypeRegularIcon);
export default __webpack_public_path__ + "static/media/item-type-regular-icon.63bba1564b046c194f491b9c361c5667.svg";
export { ForwardRef as ReactComponent };